import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Tooltip } from "react-bootstrap";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import DataTableTemplate from "../Components/DataTableTemplate";
import { PanelContainer } from "../Components/PanelContainer";
import { InputText } from "primereact/inputtext";
const ShopCells = () => {
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [userList, setUserList] = useState([]);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      name: { value: "", matchMode: "contains" },
      shop: { value: "", matchMode: "contains" },
      groupid: { value: null, matchMode: FilterMatchMode.IN },
    },
  });
  const getFilterButton = (option) => (
    <Button onClick={() => option.filterApplyCallback(option.filterModal)}>
      اعمال
    </Button>
  );

  const getFilterSelect = (options, list, key, placeholder) => (
    <select
      id={key}
      name={key}
      defaultValue=""
      className="form-control"
      value={lazyState.filters[key].value}
      onChange={(e) => options.filterCallback(e.target.value)}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {list?.map((item) => (
        <option key={item.value} value={item.value}>
          {item?.label}
        </option>
      ))}
    </select>
  );

  const getFilterInputText = (options, placeholder) => (
    <InputText
      value={options.value}
      onChange={(e) => options.filterCallback(e.target.value)}
      // optionLabel="موبایل"
      placeholder={placeholder}
      className="p-column-filter"
    />
  );

  const getFilterClearButton = (options) => (
    <Button
      type="button"
      icon="pi pi-times"
      className="btn btn-danger"
      onClick={options.filterClearCallback}
      severity="secondary"
    >
      حذف فیلتر
    </Button>
  );
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "name",
      header: "نام کاربر",
      body: (data, options) => data?.Name + " " + data?.Family,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    {
      field: "Mob",
      header: "فروشگاه ",
      filter: true,
      filterPlaceholder: "نام فروشگاه را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "نام فروشگاه را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    { field: "RegDate", header: "تاریخ " },
    { field: "lastseen", header: "مبلغ خرید" },
    { field: "ProvinceName", header: "مبلغ پرداختی" },
    { field: "CityName", header: "کش بک" },
  ];
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const excelList = userList.map((item) => ({
        "شناسه کاربر": item.uid,
        نام: item.Name,
        "نام خانوادگی": item.Family,
        "شماره موبایل": item.Mob,
        "تاریخ عضویت": item.RegDate,
        گروه: item.groupid,
        "تعداد زیر مجموعه": item.referral,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };
  const header = (
    <div className="d-flex align-items-center justify-content-between">
      <FontAwesomeIcon
        onClick={exportExcel}
        className=" p-2 rounded bg-info text-white  cursor-pointer"
        icon={"file-excel"}
      />
      <div className="d-flex align-items-center justify-content-between gap-1">
      </div>
    </div>
  );

  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
    console.log(event, "on filter");
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  return (
    <PanelContainer title={"کاربران"}>
      <Tooltip target=".export-buttons>button" position="bottom" key="" />
      <DataTableTemplate
        lazyState={lazyState}
        lazy
        select={true}
        className={"table-border"}
        columns={cols}
        list={userList}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        defaultDatatableRows={defaultDatatableRows}
        width="20rem"
        header={header}
        onFilter={onFilter}
        filters={lazyState.filters}
        loading={loading}
        onPage={onPage}
        setSelectedProducts
        selectedProducts
      />
    </PanelContainer>
  );
};

export default ShopCells;
